<div class="popup">
  <div class="popup_content">
    <div class="popup_content_heading">
      <h5 class="modal-title">Configuration for {{ data.suiteName }}</h5>
    </div>
    <div class="popup_content_content">
      <p>Choose a configuration option for this suite:</p>
      <div class="config-options">
        <button mat-raised-button (click)="selectDefault()" class="config-btn">
          Default Configuration
        </button>
        <button mat-raised-button (click)="selectCustom()" class="config-btn">
          Custom Configuration
        </button>
      </div>
      <div class="popup_content_footer">
        <button class="popup_content_footer_btn" mat-button (click)="cancel()">Cancel</button>
      </div>
    </div>
  </div>
</div>

